module.exports = __webpack_public_path__ + "img/symbol_2.73dd3291.png";